/**
 * @author        yontaek@zumper.com (Yon Taek Chung)
 * @copyright     Copyright (c) 2022, Zumper
 * @description   getShouldShowNightlyPrice
 */

import { differenceInCalendarDays } from 'date-fns'

interface props {
  filterStartDate: string | null | undefined
  filterEndDate: string | null | undefined
  longTerm: boolean | null | undefined
}

const getFormattedDateString = (date: string) => {
  const [month, day, year] = date.split('-')

  return [month, day, year].join('/')
}

export const getShouldShowNightlyPrice = ({ filterStartDate, filterEndDate, longTerm }: props) => {
  if (longTerm) {
    return false
  }
  if (filterStartDate && filterEndDate) {
    const startDateString = getFormattedDateString(filterStartDate)
    const endDateString = getFormattedDateString(filterEndDate)

    const diffInDays = differenceInCalendarDays(new Date(endDateString), new Date(startDateString))

    return diffInDays < 28
  }

  return true
}
